import React, { useEffect, useState } from 'react';
import { Users, FileText, CheckCircle } from 'lucide-react';
import { adminApi } from '../../services/api';
import BusinessApplications from './BusinessApplications';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalBusinesses: 0,
    pendingApplications: 0
  });
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const response = await adminApi.getStats();
      // Adjust for response structure
      const result = response.data || response;
      if (result) {
          setStats({
              totalUsers: result.totalUsers || 0,
              totalBusinesses: result.totalBusinesses || 0,
              pendingApplications: result.pendingApplications || 0
          });
      }
    } catch (err) {
      console.error('Failed to load admin stats', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const statCards = [
    { label: 'Total Users', value: stats.totalUsers, icon: Users },
    { label: 'Verified Businesses', value: stats.totalBusinesses, icon: CheckCircle },
    { label: 'Pending Applications', value: stats.pendingApplications, icon: FileText },
    // Placeholder for future stat like Total Orders or GMV if available
    // { label: 'Total Products', value: '-', icon: ShoppingBag, color: 'text-purple-600', bg: 'bg-purple-100 dark:bg-purple-900/30' },
  ];

  return (
    <div className='admin-dashboard-page text-foreground'>
      <h1>Dashboard Overview</h1>
      
      {/* Stats Grid */}
      <div className='admin-dashboard-stats grid grid-cols-1 gap-3 md:grid-cols-3'>
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.label} className='admin-stat-card theme-surface'>
              <div>
                <Icon size={24} />
              </div>
              <div>
                <p>{stat.label}</p>
                <p>
                  {loading ? '...' : stat.value}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Include Pending Applications widget/table below stats for quick access */}
      <div className='admin-dashboard-queue'>
          <h2>Pending Applications</h2>
          <BusinessApplications onUpdate={fetchStats} />
      </div>
    </div>
  );
};

export default AdminDashboard;
